// import { Prop } from "vue-property-decorator";
import { Component, Vue } from "vue-facing-decorator";

@Component({
    name: "HelpViewComponent",
    components: {
    },
})
export default class HelpViewComponent extends Vue {
    // results: Array<any> = [];
}
